module.exports = __webpack_public_path__ + "static/partner.condition-b23903045ae6e6c4b410f212babbd81f.png";